module.exports = __webpack_public_path__ + "img/18-ABATTAGE-TAMARIN-min.3806a588.jpg";